import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: 'What services do you specialize in?',
  answer: 'We specialize in custom Web Design, Mobile App Development (iOS & Android), E-commerce Solutions, UI/UX Design, and Digital Transformation consulting.'
}, {
  question: 'Where is Rex Technologies based?',
  answer: 'We are a UK-based company with a global presence, serving clients across Europe, USA, and Asia.'
}, {
  question: 'How do I start a project with you?',
  answer: "Simply fill out the contact form above or reach out via WhatsApp. We'll schedule a free consultation to discuss your requirements."
}, {
  question: 'What is your typical payment structure?',
  answer: 'We typically require a 50% deposit to commence work, with the remaining balance due upon project completion and approval.'
}, {
  question: 'Do you provide hosting services?',
  answer: 'Yes, we offer secure, high-speed hosting solutions and can also help you set up hosting with your preferred provider.'
}, {
  question: 'Can you redesign an existing website?',
  answer: 'Absolutely. We can modernize your existing site, improving its performance, aesthetics, and conversion rates.'
}, {
  question: 'Do you build e-commerce websites?',
  answer: 'Yes, we are experts in Shopify, WooCommerce, and custom e-commerce development.'
}, {
  question: 'Will my website be SEO friendly?',
  answer: 'Yes, all our websites are built with SEO best practices in mind, including fast loading speeds, proper structure, and meta tags.'
}, {
  question: 'Do you offer logo design and branding?',
  answer: 'Yes, we have a dedicated creative team that handles branding, logo design, and corporate identity.'
}, {
  question: 'What technologies do you use?',
  answer: 'We use modern tech stacks including React, Next.js, Node.js, React Native, Flutter, and Python.'
}, {
  question: 'Do I own the source code?',
  answer: 'Yes, upon full payment, you have 100% ownership of the source code and intellectual property.'
}, {
  question: 'How do you handle project communication?',
  answer: 'We use tools like Slack, Trello, and WhatsApp for seamless communication and provide regular progress updates.'
}, {
  question: 'Can you integrate third-party APIs?',
  answer: 'Yes, we have extensive experience integrating payment gateways, CRMs, social media APIs, and more.'
}, {
  question: 'Do you offer maintenance packages?',
  answer: 'Yes, we offer monthly maintenance packages to keep your website secure, updated, and running smoothly.'
}, {
  question: 'How long does a typical project take?',
  answer: 'Timelines vary by project. A simple site takes 2-4 weeks, while complex apps can take 3-6 months.'
}, {
  question: 'Is there a warranty period?',
  answer: 'Yes, we provide a 3-month bug-free warranty period after launch.'
}, {
  question: 'Can you help with App Store submission?',
  answer: 'Yes, we handle the entire submission process for both Apple App Store and Google Play Store.'
}, {
  question: 'Do you work with startups?',
  answer: 'Yes, we love working with startups and offer special packages to help get their MVP to market quickly.'
}, {
  question: 'Is my data secure?',
  answer: 'Security is our priority. We implement industry-standard security measures and SSL encryption.'
}, {
  question: 'Do you provide content writing services?',
  answer: 'Yes, we have professional copywriters who can create compelling content for your website.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#0a0a0a] border-t border-[#1a1a1a]" data-id="element-65">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <div className="text-center mb-16" data-id="element-67">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-68">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-400" data-id="element-69">
            Everything you need to know about working with Rex Technologies
          </p>
        </div>

        <div className="space-y-4" data-id="element-70">
          {faqs.map((faq, index) => <div key={index} className="border border-[#1a1a1a] rounded-lg bg-[#0f0f0f] overflow-hidden" data-id="element-71">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-72">
                <span className="text-lg font-medium text-white pr-8" data-id="element-73">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#0ea5e9]" data-id="element-74" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-75" />}
              </button>

              <AnimatePresence data-id="element-76">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-77">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed border-t border-[#1a1a1a] pt-4" data-id="element-78">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}